<template>
  <div class="component-block">
    <NavigationView/>
    <div class="block-container">
      <div class="config-block">
        <div class="config-top">
          Конфигурация
        </div>
        <div class="config-main">
          <div class="config-flex">
            <div class="config-main-left">
              <a
                  class="config-menu-link"
                  :class="{ 'active': configurationPage === 'Stats' }"
                  @click.prevent="configurationPage = 'Stats'"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M24 24H3C2.20435 24 1.44129 23.6839 0.87868 23.1213C0.31607 22.5587 0 21.7956 0 21L0 0H2V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H24V24Z"/>
                  <path d="M15.9998 11.0006H13.9998V20.0006H15.9998V11.0006Z"/>
                  <path d="M8 11.0006H6V20.0006H8V11.0006Z"/>
                  <path d="M20 6H18V20H20V6Z"/>
                  <path d="M12.0002 6H10.0002V20H12.0002V6Z"/>
                </svg>
                Статистика и состояние системы
              </a>
              <!-- <a
                  class="config-menu-link"
                  :class="{ 'active': configurationPage === 'Logs' }"
                  @click.prevent="configurationPage = 'Logs'"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76515 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 11.633 0.017 11.269 0.049 10.91L2.041 11.091C2.01367 11.3903 2 11.6933 2 12C2 13.9778 2.58649 15.9112 3.6853 17.5557C4.78412 19.2002 6.3459 20.4819 8.17317 21.2388C10.0004 21.9957 12.0111 22.1937 13.9509 21.8079C15.8907 21.422 17.6725 20.4696 19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8079 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17317C20.4819 6.3459 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2C11.6933 2 11.3903 2.01367 11.091 2.041L10.91 0.049C11.269 0.017 11.633 0 12 0C15.1815 0.00344108 18.2318 1.26883 20.4815 3.51852C22.7312 5.76821 23.9966 8.81846 24 12ZM5.663 4.263L4.395 2.717C3.78121 3.2216 3.2185 3.78531 2.715 4.4L4.262 5.665C4.68212 5.15305 5.15135 4.68348 5.663 4.263ZM9.142 2.415L8.571 0.5C7.80965 0.726352 7.0727 1.02783 6.371 1.4L7.31 3.166C7.89418 2.85539 8.50789 2.60381 9.142 2.415ZM3.164 7.315L1.4 6.375C1.02801 7.07678 0.726533 7.81372 0.5 8.575L2.417 9.146C2.60454 8.51172 2.85478 7.89769 3.164 7.313V7.315ZM11 6V10.277C10.7004 10.4513 10.4513 10.7004 10.277 11H7V13H10.277C10.4297 13.2652 10.6414 13.4917 10.8958 13.662C11.1501 13.8323 11.4402 13.9417 11.7436 13.9818C12.047 14.0219 12.3556 13.9917 12.6454 13.8934C12.9353 13.7951 13.1986 13.6314 13.415 13.415C13.6314 13.1986 13.7951 12.9353 13.8934 12.6454C13.9917 12.3556 14.0219 12.047 13.9818 11.7436C13.9417 11.4402 13.8323 11.1501 13.662 10.8958C13.4917 10.6414 13.2652 10.4297 13 10.277V6H11Z"/>
                </svg>
                Логи, ошибки и события
              </a> -->
              <!-- <a
                  class="config-menu-link"
                  :class="{ 'active': configurationPage === 'Notifications' }"
                  @click.prevent="configurationPage = 'Notifications'"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M1.0369 5.88891L-0.00610352 4.18891L6.7289 0.0619125L7.7709 1.76791L1.0369 5.88891ZM22.2739 16.2169L18.1489 22.8999L19.8489 23.9509L23.9739 17.2669L22.2739 16.2169ZM20.9239 14.5999L15.9999 22.5829C15.7755 22.963 15.4667 23.2864 15.0973 23.5281C14.728 23.7698 14.308 23.9234 13.8699 23.9769C13.7438 23.9922 13.6169 23.9999 13.4899 23.9999C13.1084 24.0002 12.7306 23.9249 12.3784 23.7783C12.0262 23.6317 11.7065 23.4168 11.4379 23.1459L10.4749 22.1829C9.55997 22.8233 8.44867 23.1208 7.33618 23.0233C6.22368 22.9257 5.18113 22.4393 4.39164 21.6494C3.60215 20.8596 3.11619 19.8168 3.01913 18.7043C2.92207 17.5917 3.22011 16.4805 3.8609 15.5659L0.852896 12.5569C0.547761 12.2518 0.314284 11.8826 0.169364 11.4761C0.0244436 11.0697 -0.0282946 10.6361 0.0149664 10.2067C0.0582274 9.77736 0.196405 9.36299 0.419499 8.9936C0.642593 8.62421 0.945022 8.30905 1.3049 8.07091L9.0669 3.32091C10.5343 2.38038 12.259 1.92191 13.9998 2.00958C15.7405 2.09726 17.4104 2.7267 18.7759 3.80991L20.6679 1.91791L22.0819 3.33191L20.1819 5.23191C21.2191 6.54451 21.8434 8.1355 21.9755 9.80324C22.1076 11.471 21.7416 13.1404 20.9239 14.5999ZM9.0099 20.7179L5.3179 17.0229C5.04328 17.5397 4.94273 18.1313 5.03119 18.7098C5.11965 19.2883 5.3924 19.8228 5.8089 20.2339C6.22853 20.6329 6.76064 20.8933 7.33319 20.9799C7.90574 21.0665 8.49105 20.975 9.0099 20.7179ZM18.1299 5.89991C17.0982 4.86023 15.7411 4.20587 14.2852 4.04608C12.8292 3.88629 11.3625 4.23073 10.1299 5.02191L2.3779 9.75791C2.27184 9.83202 2.18342 9.9286 2.11895 10.0408C2.05448 10.153 2.01554 10.278 2.0049 10.4069C1.99046 10.5414 2.00651 10.6774 2.05187 10.8048C2.09723 10.9322 2.17073 11.0478 2.2669 11.1429L12.8529 21.7319C12.95 21.8319 13.0694 21.9076 13.2013 21.9527C13.3332 21.9979 13.4738 22.0113 13.6119 21.9919C13.7501 21.9752 13.8825 21.9267 13.9987 21.8502C14.115 21.7737 14.2119 21.6712 14.2819 21.5509L19.2019 13.5779C19.8804 12.3551 20.1428 10.9447 19.9494 9.55971C19.756 8.17469 19.1174 6.89014 18.1299 5.89991Z"/>
                </svg>
                Настройка уведомлений
              </a> -->
            </div>
            <div class="config-main-right">
              <ConfigurationStatsView v-if="configurationPage == 'Stats'"/>
              <!-- <ConfigurationLogsView v-if="configurationPage == 'Logs'"/>
              <ConfigurationNotificationsView v-if="configurationPage == 'Notifications'"/> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NavigationView from "@/components/NavigationView";
import ConfigurationStatsView from "@/components/ConfigurationStatsView";
import store from "@/store";

export default {
  name: "ConfigurationView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push('/login');
    }
    if (!store.state.user.roles.includes('ROLE_CONFIG')) {
      this.$router.push('/');
    }
  },
  data() {
    return {
      configurationPage: "Stats"
    };
  },
  components: {
    NavigationView,
    ConfigurationStatsView,
  },
  methods: {}
};
</script>

<style scoped>

.block-container {
  /*background-image: url("../assets/images/backfon.jpg");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  /*padding: 30px;*/
  overflow: hidden;
}

.config-block {
  background: #FFFFFF;
  /*border-radius: 10px;*/
  height: 100%;
  position: relative;
  box-shadow: 0px 5px 10px #aaacbd;
}

.config-top {
  padding: 20px;
  font-size: 18px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #005291;
}

.config-main {
  height: calc(100% - 67px);
}

.config-flex {
  display: flex;
  height: 100%;
}

.config-main-left {
  background: #DDE5ED;
  padding: 12px 0;
  flex-shrink: 0;
  border-radius: 0 0 0 10px;
  overflow: auto;
}

.config-menu-link {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 20px;
  background: transparent;
  cursor: pointer;
  color: #374957;
  transition: all .4s;
  font-size: 14px;
  text-decoration: none;
}

.config-menu-link svg {
  fill: #374957;
  margin-right: 13px;
  transition: all .4s;
}

.config-menu-link:hover, .config-menu-link.active {
  background: #005291;
  color: #FFFFFF;
}

.config-menu-link:hover svg, .config-menu-link.active svg {
  fill: #FFFFFF;
}

.config-main-right {
  width: 100%;
  position: relative;
}

</style>